<div class="content-wrapper">
  <section class="content">
    <div class="box">
      <div class="box-body">
        <form [formGroup]="EmployeeRecoveryRecordsForm" (ngSubmit)="SearchRecord()">
          <div class="panel panel-default">
            <header class="panel-heading">
              <h5 class="panel-title">View All Records</h5>
            </header>
            <header class="panel-heading">
              <h5 class="panel-title">Search Criteria</h5>
            </header>
            <div class="panel-body">
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Employee Name/GPN/GUI/Email</label>
                  <input class="form-control" placeholder="Employee Name/GPN/GUI/Email" maxlength="200"
                    formControlName="UserName" appPreventSpecialChars>
                </div>
                <div class="form-group col-md-6">
                  <label>Employee Location</label>
                  <input class="form-control" placeholder="employee location" CharOnly maxlength="200"
                    formControlName="UserLocation" appPreventSpecialChars>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Reported Location</label>
                  <p-dropdown 
                    [options]="ReportedLocationList" 
                    placeholder="--Select Reported Location--"
                    formControlName="ReportedLocationID"
                    filter="true" 
                    >
                  </p-dropdown>
                </div>
                <div class="form-group col-md-6">
                  <label>Created By</label>
                  <input class="form-control" placeholder="created by" CharOnly maxlength="200"
                    formControlName="CreatedBy" appPreventSpecialChars>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Asset Type</label>
                  <p-dropdown [options]="AssestTypeList" placeholder="--Select Asset Type--"
                    formControlName="AssetTypeID" filter="true">
                  </p-dropdown>
                </div>
                <div class="form-group col-md-6">
                  <label>Penalty Type</label>
                  <p-dropdown [options]="PenaltyTypeList" placeholder="--Select Penalty Type--"
                    formControlName="PenaltyTypeID" filter="true">
                  </p-dropdown>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Entity</label>
                  <p-dropdown [options]="FirmList" placeholder="--Select Entity Type--" formControlName="entityid"
                    filter="true">
                  </p-dropdown>
                </div>
                <div class="form-group col-md-6">
                  <label>Status</label>
                  <p-dropdown [options]="ITRecoveryStatusList" placeholder="--Select Status--"
                    formControlName="ITRecoveryStatus" filter="true">
                  </p-dropdown>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>From Date</label>
                  <div class="input-group">
                    <input [matDatepicker]="FromDate" ng-model-options="{timezone: 'UTC'}"
                      formControlName="FromRecoveryDate" class="form-control" placeholder="from date" readonly
                      (dateChange)="orgValueChange('FromDate')">
                    <div class="input-group-append">
                      <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix [for]="FromDate">
                      </mat-datepicker-toggle>
                      <mat-datepicker #FromDate></mat-datepicker>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>To Date</label>
                  <div class="input-group">
                    <input [matDatepicker]="ToDate" ng-model-options="{timezone: 'UTC'}"
                      formControlName="ToRecoveryDate" class="form-control" placeholder="to date" readonly
                      (dateChange)="orgValueChange('ToDate')">
                    <div class="input-group-append">
                      <mat-datepicker-toggle class="input-group-addon iconWithInput" matSuffix [for]="ToDate">
                      </mat-datepicker-toggle>
                      <mat-datepicker #ToDate></mat-datepicker>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Record ID/Waiver ID</label>
                  <input class="form-control" placeholder="Record ID/Waiver ID" maxlength="20" formControlName="RecoveryID" appPreventSpecialChars>
                </div>
              </div>
            </div>
            <div class="panel-footer" style="text-align: right">
              <button mat-stroked-button type="submit">Get Result</button>
              <button mat-stroked-button type="button" (click)="Reset()">Reset</button>
              <button type="button" mat-stroked-button (click)="Export()">Export</button>
              <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
            </div>
          </div>

          <div class="tabel-loading-shade" *ngIf="isLoadingResults">
            <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
          </div>
          <div class="table-container">
            <table mat-table [dataSource]="FinanceViewDataSource" style="width:100% !important">
              <!-- Position Column -->
              <ng-container matColumnDef="RecordID">
                <th mat-header-cell *matHeaderCellDef> Record ID </th>
                <td mat-cell *matCellDef="let element" style="color: dodgerblue"><a> <span
                      (click)="ShowDetails(element.RequestEntityId)"
                      style="display:none">{{element.RequestEntityId}}</span> {{element.RecordID}}</a>
                </td>
              </ng-container>
              <!-- Name Column -->
              <ng-container matColumnDef="EmployeeName">
                <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.EmployeeName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="EmailID">
                <th mat-header-cell *matHeaderCellDef> Employee Email </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.EmailID}} </td>
              </ng-container>

              <ng-container matColumnDef="EmployeeLocation">
                <th mat-header-cell *matHeaderCellDef> Employee Location </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.EmployeeLocation}}
                </td>
              </ng-container>
              <ng-container matColumnDef="ReportedLocation">
                <th mat-header-cell *matHeaderCellDef> Reported Location </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.ReportedLocation}}
                </td>
              </ng-container>
              <ng-container matColumnDef="AssetType">
                <th mat-header-cell *matHeaderCellDef> Asset Type </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.AssetType}} </td>
              </ng-container>
              <ng-container matColumnDef="PenaltyType">
                <th mat-header-cell *matHeaderCellDef> Penalty Type </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.PenaltyType}} </td>
              </ng-container>
              <ng-container matColumnDef="PenaltyAmount">
                <th mat-header-cell *matHeaderCellDef> Penalty Amount </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.PenaltyAmount}}
                </td>
              </ng-container>
              <ng-container matColumnDef="WaiverID">
                <th mat-header-cell *matHeaderCellDef> Waiver IDs </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.WaiverID}} </td>
              </ng-container>
              <ng-container matColumnDef="CreatedBy">
                <th mat-header-cell *matHeaderCellDef> Created By </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.CreatedBy}} </td>
              </ng-container>
              <ng-container matColumnDef="CreatedDate">
                <th mat-header-cell *matHeaderCellDef> Created Date </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.CreatedDate | date:
                  'dd/MM/yyyy'}} </td>
              </ng-container>
              <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.Status}} </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer;"
                (click)="ShowDetails(row)"></tr>
            </table>
          </div>
        </form>
        <mat-paginator [length]="_global.length" (page)="onPaginateChange($event)"></mat-paginator>
        <div style="float:right;">Page : <input type="text" numbersOnly style="width:50px;height:10px;"
            [(ngModel)]="_global.pageIndex" /> of {{_global.totalPage}} &nbsp;&nbsp;&nbsp;&nbsp;<button type="button"
            mat-stroked-button (click)="GoToPage()">Go</button></div>
      </div>
    </div>
  </section>
</div>